export const PROCEDURE_CODES = {
  CREATININA: '0302023-001-0062',
  VFG: 'VFG',
  ESTADO_1_PARASITOLOGICO_SERIADO: 'ESTADO_1_PARASITOLOGICO_SERIADO',
  PERSONA_QUE_ENTREGA_1_PARASITOLOGICO_SERIADO: 'PERSONA_QUE_ENTREGA_1_PARASITOLOGICO_SERIADO',
  FECHA_QUE_ENTREGA_1_PARASITOLOGICO_SERIADO: 'FECHA_QUE_ENTREGA_1_PARASITOLOGICO_SERIADO',
  PERSONA_QUE_RECIBE_1_PARASITOLOGICO_SERIADO: 'PERSONA_QUE_RECIBE_1_PARASITOLOGICO_SERIADO',
  FECHA_DE_RECEPCION_1_PARASITOLOGICO_SERIADO: 'FECHA_DE_RECEPCION_1_PARASITOLOGICO_SERIADO',
  PERSONA_QUE_ENVIO_A_LABORATORIO_1_PARASITOLOGICO_SERIADO: 'PERSONA_QUE_ENVIO_A_LABORATORIO_1_PARASITOLOGICO_SERIADO',
  FECHA_DE_ENVIO_A_LABORATORIO_1_PARASITOLOGICO_SERIADO: 'FECHA_DE_ENVIO_A_LABORATORIO_1_PARASITOLOGICO_SERIADO',
  ESTADO_1_TEST_DE_GRAHAM: 'ESTADO_1_TEST_DE_GRAHAM',
  PERSONA_QUE_ENTREGA_1_TEST_DE_GRAHAM: 'PERSONA_QUE_ENTREGA_1_TEST_DE_GRAHAM',
  FECHA_QUE_ENTREGA_1_TEST_DE_GRAHAM: 'FECHA_QUE_ENTREGA_1_TEST_DE_GRAHAM',
  PERSONA_QUE_RECIBE_1_TEST_DE_GRAHAM: 'PERSONA_QUE_RECIBE_1_TEST_DE_GRAHAM',
  FECHA_DE_RECEPCION_1_TEST_DE_GRAHAM: 'FECHA_DE_RECEPCION_1_TEST_DE_GRAHAM',
  PERSONA_QUE_ENVIO_A_LABORATORIO_1_TEST_DE_GRAHAM: 'PERSONA_QUE_ENVIO_A_LABORATORIO_1_TEST_DE_GRAHAM',
  FECHA_DE_ENVIO_A_LABORATORIO_1_TEST_DE_GRAHAM: 'FECHA_DE_ENVIO_A_LABORATORIO_1_TEST_DE_GRAHAM',
};

export const CALCULATOR_TYPES = {
  VFG: 'vfg',
  ESTADO_1_PARASITOLOGICO_SERIADO: 'estado_1_parasitologico_seriado',
  PERSONA_QUE_ENTREGA_1_PARASITOLOGICO_SERIADO: 'persona_que_entrega_1_parasitologico_seriado',
  FECHA_QUE_ENTREGA_1_PARASITOLOGICO_SERIADO: 'fecha_que_entrega_1_parasitologico_seriado',
  PERSONA_QUE_RECIBE_1_PARASITOLOGICO_SERIADO: 'persona_que_recibe_1_parasitologico_seriado',
  FECHA_DE_RECEPCION_1_PARASITOLOGICO_SERIADO: 'fecha_de_recepcion_1_parasitologico_seriado',
  PERSONA_QUE_ENVIO_A_LABORATORIO_1_PARASITOLOGICO_SERIADO: 'persona_que_envio_a_laboratorio_1_parasitologico_seriado',
  FECHA_DE_ENVIO_A_LABORATORIO_1_PARASITOLOGICO_SERIADO: 'fecha_de_envio_a_laboratorio_1_parasitologico_seriado',
  ESTADO_1_TEST_DE_GRAHAM: 'estado_1_test_de_graham',
  PERSONA_QUE_ENTREGA_1_TEST_DE_GRAHAM: 'persona_que_entrega_1_test_de_graham',
  FECHA_QUE_ENTREGA_1_TEST_DE_GRAHAM: 'fecha_que_entrega_1_test_de_graham',
  PERSONA_QUE_RECIBE_1_TEST_DE_GRAHAM: 'persona_que_recibe_1_test_de_graham',
  FECHA_DE_RECEPCION_1_TEST_DE_GRAHAM: 'fecha_de_recepcion_1_test_de_graham',
  PERSONA_QUE_ENVIO_A_LABORATORIO_1_TEST_DE_GRAHAM: 'persona_que_envio_a_laboratorio_1_test_de_graham',
  FECHA_DE_ENVIO_A_LABORATORIO_1_TEST_DE_GRAHAM: 'fecha_de_envio_a_laboratorio_1_test_de_graham',
};

export const PROCEDURE_CALCULATOR_MAP = {
  [PROCEDURE_CODES.CREATININA]: {
    type: CALCULATOR_TYPES.VFG,
    targetFields: [PROCEDURE_CODES.VFG],
  },
  [PROCEDURE_CODES.ESTADO_1_PARASITOLOGICO_SERIADO]: {
    type: CALCULATOR_TYPES.ESTADO_1_PARASITOLOGICO_SERIADO,
    targetFields: [
      PROCEDURE_CODES.PERSONA_QUE_ENTREGA_1_PARASITOLOGICO_SERIADO,
      PROCEDURE_CODES.FECHA_QUE_ENTREGA_1_PARASITOLOGICO_SERIADO,
      PROCEDURE_CODES.PERSONA_QUE_RECIBE_1_PARASITOLOGICO_SERIADO,
      PROCEDURE_CODES.FECHA_DE_RECEPCION_1_PARASITOLOGICO_SERIADO,
      PROCEDURE_CODES.PERSONA_QUE_ENVIO_A_LABORATORIO_1_PARASITOLOGICO_SERIADO,
      PROCEDURE_CODES.FECHA_DE_ENVIO_A_LABORATORIO_1_PARASITOLOGICO_SERIADO,
    ],
  },
  [PROCEDURE_CODES.ESTADO_1_TEST_DE_GRAHAM]: {
    type: CALCULATOR_TYPES.ESTADO_1_TEST_DE_GRAHAM,
    targetFields: [
      PROCEDURE_CODES.PERSONA_QUE_ENTREGA_1_TEST_DE_GRAHAM,
      PROCEDURE_CODES.FECHA_QUE_ENTREGA_1_TEST_DE_GRAHAM,
      PROCEDURE_CODES.PERSONA_QUE_RECIBE_1_TEST_DE_GRAHAM,
      PROCEDURE_CODES.FECHA_DE_RECEPCION_1_TEST_DE_GRAHAM,
      PROCEDURE_CODES.PERSONA_QUE_ENVIO_A_LABORATORIO_1_TEST_DE_GRAHAM,
      PROCEDURE_CODES.FECHA_DE_ENVIO_A_LABORATORIO_1_TEST_DE_GRAHAM,
    ],
  },
};
